<template>
  <div>
    <div>
      <el-button type="primary" class="es-push-address-button" @click="pushAdressNew()">
        {{$translate('lang.E3202103100008', { defaultText: '新增地址' })}}
      </el-button>
    </div>
    <el-table ref="multipleTable" :data="addressSet" tooltip-effect="dark" style="width: 100%" border>
      <el-table-column :label="config.modificationAddress.labelList[0]" prop="address" ></el-table-column>
      <el-table-column :label="config.modificationAddress.labelList[1]" prop="port" ></el-table-column>
      <el-table-column :label="$translate('lang.E3202101250010', { defaultText: '状态' })" >
        <template slot-scope="scope">
          <span :style="{color:scope.row.state===0?'':'red'}">
            {{scope.row.state===0?$translate('lang.E3202102260004', { defaultText: '启用' }):$translate('lang.E3202102260003', { defaultText: '停用' })}}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="config.modificationAddress.labelList[2]">
        <template slot-scope="scope">
          <el-button type="text" class="operating-button" @click="deleteToday(scope.row)">
            {{scope.row.state==0?$translate('lang.E3202102260003', { defaultText: '停用' }):$translate('lang.E3202102260004', { defaultText: '启用' })}}
          </el-button>
          <el-button type="text" @click="changeOldAdress(scope.row)">{{$translate('lang.E3202102260009', { defaultText: '编辑' })}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import config from '../esConfig.js';
export default {

    props: ['addressSet'],
    data() {
        return {
            config: config
        };
    },

    methods: {
        deleteToday(row) {
            this.$confirm(this.$translate('lang.E3202103100015', { defaultText: '是否确认此操作?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    if (row.state === 1) {
                        this.$message.success(this.$translate('lang.E3202103100020', { defaultText: '启用成功' }));
                        row.state = 0;
                        this.$emit('adressState', row);
                    } else {
                        this.$message.success(this.$translate('lang.E3202103100021', { defaultText: '禁用成功' }));
                        row.state = 1;
                        this.$emit('adressState', row);
                    }
                })
                .catch(() => {
                });
        },
        pushAdressNew() {
            this.$emit('openAdressNew');
        },
        changeOldAdress(row) {
            this.pushAdressNew();
            this.$emit('changeOldAdress', row);
        }
    }
};
</script>
<style lang="less">
.es-push-address-button{
  margin-bottom: 10px
}
</style>
